import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if @fullscreen}}
  <div class="title">
    <h2>
      <a
        class="fancy-title"
        href
        {{on "click" @jumpTop}}
      >{{this.topicTitle}}</a>
    </h2>
    {{#if (or this.siteSettings.topic_featured_link_enabled this.showTags)}}
      <div class="topic-header-extra">
        {{#if this.showTags}}
          <div class="list-tags">
            {{discourse-tags @model mode="list" tags=@model.tags}}
          </div>
        {{/if}}
        {{#if this.siteSettings.topic_featured_link_enabled}}
          {{topic-featured-link @model}}
        {{/if}}
      </div>
    {{/if}}

    {{#if (and (not @model.isPrivateMessage) @model.category)}}
      <div class="topic-category">
        {{#if @model.category.parentCategory}}
          {{category-link @model.category.parentCategory}}
        {{/if}}
        {{category-link @model.category}}
      </div>
    {{/if}}
    {{#if this.excerpt}}
      <div class="post-excerpt">{{html-safe this.excerpt}}</div>
    {{/if}}
  </div>
{{/if}}

{{#if (and (not @fullscreen) this.currentUser)}}
  <div class="timeline-controls">
    <PluginOutlet
      @name="timeline-controls-before"
      @outletArgs={{hash model=@model}}
    />
    <TopicAdminMenu
      @topic={{@model}}
      @addKeyboardTargetClass={{true}}
      @toggleMultiSelect={{@toggleMultiSelect}}
      @showTopicSlowModeUpdate={{@showTopicSlowModeUpdate}}
      @deleteTopic={{@deleteTopic}}
      @recoverTopic={{@recoverTopic}}
      @toggleClosed={{@toggleClosed}}
      @toggleArchived={{@toggleArchived}}
      @toggleVisibility={{@toggleVisibility}}
      @showTopicTimerModal={{@showTopicTimerModal}}
      @showFeatureTopic={{@showFeatureTopic}}
      @showChangeTimestamp={{@showChangeTimestamp}}
      @resetBumpDate={{@resetBumpDate}}
      @convertToPublicTopic={{@convertToPublicTopic}}
      @convertToPrivateMessage={{@convertToPrivateMessage}}
    />
  </div>
{{/if}}

{{#if this.displayTimeLineScrollArea}}
  <UserTip
    @id="topic_timeline"
    @titleText={{i18n "user_tips.topic_timeline.title"}}
    @contentText={{i18n "user_tips.topic_timeline.content"}}
    @placement="left"
    @triggerSelector=".timeline-scrollarea-wrapper"
  />

  <div class="timeline-scrollarea-wrapper">
    <div class="timeline-date-wrapper">
      <a
        class="start-date"
        onClick={{this.updatePercentage}}
        title={{this.startDate}}
      >
        <span>
          {{this.startDate}}
        </span>
      </a>
    </div>
    <div
      class="timeline-scrollarea"
      style={{this.timelineScrollareaStyle}}
      {{did-insert this.registerScrollarea}}
    >
      <div
        class="timeline-padding"
        style={{this.beforePadding}}
        onClick={{this.updatePercentage}}
      ></div>
      <TopicTimeline::Scroller
        @current={{this.current}}
        @total={{this.total}}
        @onGoBack={{this.onGoBack}}
        @fullscreen={{@fullscreen}}
        @showDockedButton={{this.showDockedButton}}
        @date={{this.date}}
        @didStartDrag={{this.didStartDrag}}
        @dragMove={{this.dragMove}}
        @didEndDrag={{this.didEndDrag}}
        {{did-insert this.registerScroller}}
      />
      <div
        class="timeline-padding"
        style={{this.afterPadding}}
        onClick={{this.updatePercentage}}
      ></div>

      {{#if (and this.hasBackPosition this.showButton)}}
        <div class="timeline-last-read" style={{this.lastReadStyle}}>
          {{d-icon "minus" class="progress"}}
          <TopicTimeline::BackButton @onGoBack={{this.goBack}} />
        </div>
      {{/if}}
    </div>

    <div class="timeline-date-wrapper">
      <a class="now-date" onClick={{this.updatePercentage}}>
        <span>
          {{age-with-tooltip this.nowDate this.nowDateOptions}}
        </span>
      </a>
    </div>
  </div>

  <div class="timeline-footer-controls">
    {{#if this.displaySummary}}
      <button
        type="button"
        class="show-summary btn btn-small"
        title={{i18n "summary.short_title"}}
        {{on "click" @showTopReplies}}
      >
        {{d-icon "layer-group"}}
        {{i18n "summary.short_label"}}
      </button>
    {{/if}}

    {{#if (and this.currentUser (not @fullscreen))}}
      {{#if this.canCreatePost}}
        <button
          type="button"
          class="btn btn-default create reply-to-post no-text btn-icon"
          title={{i18n "topic.reply.help"}}
          {{on "click" (fn @replyToPost null)}}
        >
          {{d-icon "reply"}}
        </button>
      {{/if}}
    {{/if}}

    {{#if @fullscreen}}
      <button
        type="button"
        class="timeline-open-jump-to-post-prompt-btn btn btn-text jump-to-post"
        title={{i18n "topic.progress.jump_prompt_long"}}
        {{on "click" @jumpToPostPrompt}}
      >
        <span class="d-button-label">
          {{i18n "topic.progress.jump_prompt"}}
        </span>
      </button>
    {{/if}}

    {{#if this.currentUser}}
      <TopicNotificationsButton
        @notificationLevel={{@model.details.notification_level}}
        @topic={{@model}}
        @showFullTitle={{false}}
        @appendReason={{false}}
        @placement="bottom-end"
        @showCaret={{false}}
      />
      {{#if @mobileView}}
        <TopicAdminMenu
          @topic={{@model}}
          @addKeyboardTargetClass={{true}}
          @openUpwards={{true}}
        />
      {{/if}}
    {{/if}}
    <PluginOutlet
      @name="timeline-footer-controls-after"
      @outletArgs={{hash model=@model fullscreen=@fullscreen}}
    />
  </div>
{{/if}}
*/
{
  "id": "I2CmKC8N",
  "block": "[[[41,[30,1],[[[1,\"  \"],[10,0],[14,0,\"title\"],[12],[1,\"\\n    \"],[10,\"h2\"],[12],[1,\"\\n      \"],[11,3],[24,0,\"fancy-title\"],[24,6,\"\"],[4,[38,1],[\"click\",[30,2]],null],[12],[1,[30,0,[\"topicTitle\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[28,[37,2],[[30,0,[\"siteSettings\",\"topic_featured_link_enabled\"]],[30,0,[\"showTags\"]]],null],[[[1,\"      \"],[10,0],[14,0,\"topic-header-extra\"],[12],[1,\"\\n\"],[41,[30,0,[\"showTags\"]],[[[1,\"          \"],[10,0],[14,0,\"list-tags\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[[30,3]],[[\"mode\",\"tags\"],[\"list\",[30,3,[\"tags\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"siteSettings\",\"topic_featured_link_enabled\"]],[[[1,\"          \"],[1,[28,[35,4],[[30,3]],null]],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,5],[[28,[37,6],[[30,3,[\"isPrivateMessage\"]]],null],[30,3,[\"category\"]]],null],[[[1,\"      \"],[10,0],[14,0,\"topic-category\"],[12],[1,\"\\n\"],[41,[30,3,[\"category\",\"parentCategory\"]],[[[1,\"          \"],[1,[28,[35,7],[[30,3,[\"category\",\"parentCategory\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"        \"],[1,[28,[35,7],[[30,3,[\"category\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"excerpt\"]],[[[1,\"      \"],[10,0],[14,0,\"post-excerpt\"],[12],[1,[28,[35,8],[[30,0,[\"excerpt\"]]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,5],[[28,[37,6],[[30,1]],null],[30,0,[\"currentUser\"]]],null],[[[1,\"  \"],[10,0],[14,0,\"timeline-controls\"],[12],[1,\"\\n    \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"timeline-controls-before\",[28,[37,10],null,[[\"model\"],[[30,3]]]]]],null],[1,\"\\n    \"],[8,[39,11],null,[[\"@topic\",\"@addKeyboardTargetClass\",\"@toggleMultiSelect\",\"@showTopicSlowModeUpdate\",\"@deleteTopic\",\"@recoverTopic\",\"@toggleClosed\",\"@toggleArchived\",\"@toggleVisibility\",\"@showTopicTimerModal\",\"@showFeatureTopic\",\"@showChangeTimestamp\",\"@resetBumpDate\",\"@convertToPublicTopic\",\"@convertToPrivateMessage\"],[[30,3],true,[30,4],[30,5],[30,6],[30,7],[30,8],[30,9],[30,10],[30,11],[30,12],[30,13],[30,14],[30,15],[30,16]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"displayTimeLineScrollArea\"]],[[[1,\"  \"],[8,[39,12],null,[[\"@id\",\"@titleText\",\"@contentText\",\"@placement\",\"@triggerSelector\"],[\"topic_timeline\",[28,[37,13],[\"user_tips.topic_timeline.title\"],null],[28,[37,13],[\"user_tips.topic_timeline.content\"],null],\"left\",\".timeline-scrollarea-wrapper\"]],null],[1,\"\\n\\n  \"],[10,0],[14,0,\"timeline-scrollarea-wrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"timeline-date-wrapper\"],[12],[1,\"\\n      \"],[10,3],[14,0,\"start-date\"],[15,\"onClick\",[30,0,[\"updatePercentage\"]]],[15,\"title\",[30,0,[\"startDate\"]]],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[30,0,[\"startDate\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,0],[24,0,\"timeline-scrollarea\"],[16,5,[30,0,[\"timelineScrollareaStyle\"]]],[4,[38,14],[[30,0,[\"registerScrollarea\"]]],null],[12],[1,\"\\n      \"],[10,0],[14,0,\"timeline-padding\"],[15,5,[30,0,[\"beforePadding\"]]],[15,\"onClick\",[30,0,[\"updatePercentage\"]]],[12],[13],[1,\"\\n      \"],[8,[39,15],[[4,[38,14],[[30,0,[\"registerScroller\"]]],null]],[[\"@current\",\"@total\",\"@onGoBack\",\"@fullscreen\",\"@showDockedButton\",\"@date\",\"@didStartDrag\",\"@dragMove\",\"@didEndDrag\"],[[30,0,[\"current\"]],[30,0,[\"total\"]],[30,0,[\"onGoBack\"]],[30,1],[30,0,[\"showDockedButton\"]],[30,0,[\"date\"]],[30,0,[\"didStartDrag\"]],[30,0,[\"dragMove\"]],[30,0,[\"didEndDrag\"]]]],null],[1,\"\\n      \"],[10,0],[14,0,\"timeline-padding\"],[15,5,[30,0,[\"afterPadding\"]]],[15,\"onClick\",[30,0,[\"updatePercentage\"]]],[12],[13],[1,\"\\n\\n\"],[41,[28,[37,5],[[30,0,[\"hasBackPosition\"]],[30,0,[\"showButton\"]]],null],[[[1,\"        \"],[10,0],[14,0,\"timeline-last-read\"],[15,5,[30,0,[\"lastReadStyle\"]]],[12],[1,\"\\n          \"],[1,[28,[35,16],[\"minus\"],[[\"class\"],[\"progress\"]]]],[1,\"\\n          \"],[8,[39,17],null,[[\"@onGoBack\"],[[30,0,[\"goBack\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"timeline-date-wrapper\"],[12],[1,\"\\n      \"],[10,3],[14,0,\"now-date\"],[15,\"onClick\",[30,0,[\"updatePercentage\"]]],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[35,18],[[30,0,[\"nowDate\"]],[30,0,[\"nowDateOptions\"]]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"timeline-footer-controls\"],[12],[1,\"\\n\"],[41,[30,0,[\"displaySummary\"]],[[[1,\"      \"],[11,\"button\"],[24,0,\"show-summary btn btn-small\"],[16,\"title\",[28,[37,13],[\"summary.short_title\"],null]],[24,4,\"button\"],[4,[38,1],[\"click\",[30,17]],null],[12],[1,\"\\n        \"],[1,[28,[35,16],[\"layer-group\"],null]],[1,\"\\n        \"],[1,[28,[35,13],[\"summary.short_label\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"currentUser\"]],[28,[37,6],[[30,1]],null]],null],[[[41,[30,0,[\"canCreatePost\"]],[[[1,\"        \"],[11,\"button\"],[24,0,\"btn btn-default create reply-to-post no-text btn-icon\"],[16,\"title\",[28,[37,13],[\"topic.reply.help\"],null]],[24,4,\"button\"],[4,[38,1],[\"click\",[28,[37,19],[[30,18],null],null]],null],[12],[1,\"\\n          \"],[1,[28,[35,16],[\"reply\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[11,\"button\"],[24,0,\"timeline-open-jump-to-post-prompt-btn btn btn-text jump-to-post\"],[16,\"title\",[28,[37,13],[\"topic.progress.jump_prompt_long\"],null]],[24,4,\"button\"],[4,[38,1],[\"click\",[30,19]],null],[12],[1,\"\\n        \"],[10,1],[14,0,\"d-button-label\"],[12],[1,\"\\n          \"],[1,[28,[35,13],[\"topic.progress.jump_prompt\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentUser\"]],[[[1,\"      \"],[8,[39,20],null,[[\"@notificationLevel\",\"@topic\",\"@showFullTitle\",\"@appendReason\",\"@placement\",\"@showCaret\"],[[30,3,[\"details\",\"notification_level\"]],[30,3],false,false,\"bottom-end\",false]],null],[1,\"\\n\"],[41,[30,20],[[[1,\"        \"],[8,[39,11],null,[[\"@topic\",\"@addKeyboardTargetClass\",\"@openUpwards\"],[[30,3],true,true]],null],[1,\"\\n\"]],[]],null]],[]],null],[1,\"    \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"timeline-footer-controls-after\",[28,[37,10],null,[[\"model\",\"fullscreen\"],[[30,3],[30,1]]]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@fullscreen\",\"@jumpTop\",\"@model\",\"@toggleMultiSelect\",\"@showTopicSlowModeUpdate\",\"@deleteTopic\",\"@recoverTopic\",\"@toggleClosed\",\"@toggleArchived\",\"@toggleVisibility\",\"@showTopicTimerModal\",\"@showFeatureTopic\",\"@showChangeTimestamp\",\"@resetBumpDate\",\"@convertToPublicTopic\",\"@convertToPrivateMessage\",\"@showTopReplies\",\"@replyToPost\",\"@jumpToPostPrompt\",\"@mobileView\"],false,[\"if\",\"on\",\"or\",\"discourse-tags\",\"topic-featured-link\",\"and\",\"not\",\"category-link\",\"html-safe\",\"plugin-outlet\",\"hash\",\"topic-admin-menu\",\"user-tip\",\"i18n\",\"did-insert\",\"topic-timeline/scroller\",\"d-icon\",\"topic-timeline/back-button\",\"age-with-tooltip\",\"fn\",\"topic-notifications-button\"]]",
  "moduleName": "discourse/components/topic-timeline/container.hbs",
  "isStrictMode": false
});